<div class="camera-indicator">
  @if (cameraConnected$ | async; as cameraConnected) {
    <mat-icon
      svgIcon="cm:video-camera"
      [ngClass]="cameraConnected ? 'success' : 'error'"
    ></mat-icon>
  }
</div>
